export const locale = {
    lang: 'de',
    data: {
      'CIERRE': {
         'LABEL1': 'Umfrage in Bearbeitung',
         'LABEL2': 'Siehe Fortschritt',
         'LABEL3': 'Umfrage abgeschlossen',
         'LABEL4': 'Ergebnis sehen',
         'BTN_CIERRE': 'Jetzt schließen',
         'ALERT':{
           'MESSAGE': 'Bestätigen Sie, den voraussichtlichen Abschluss der Umfrage durchzuführen?',
            'BTN_CONFIRM': 'Ja',
            'BTN_CANCEL': 'Nein'
         },
         'LINK': 'Gehen Sie zum nächsten Link, um den aktuellen Fortschritt der Umfrage zu sehen',
         'ACTIONS':{
           'TITULO': 'Aktionen',
         'WANNADO': 'Was wollen Sie tun?'
         },
         'COMPLETO':{
           'TAG': 'Die Umfrage wurde erfolgreich beendet',
           'CARDTIT': 'Ergebnisabfrage',
           'LINK': 'Gehen Sie zum nächsten Link, um die erzielten Ergebnisse der Umfrage zu sehen'
         }
      },


      'ALERTS':{
        'OK':'OK'
      },
      'CERTIFICAR': {
        'TITUTEST': 'ASDGF',
          'IDIOMAS': {
            'ELEGIR': 'Choose',
            'STATUS': {
              'PEND': 'Schritt abgeschlossen',
              'DONE': 'Schritt abgeschlossen',
          },
          'MENSAJES':{
            'ADDLANG': 'Sie haben gewählt ',
            'NOADITIONAL': 'Sie haben sich entschieden, keine zusätzlichen Sprachen einzustellen',
            'ERRORADD': 'Bei der Auswahl der Sprache ist ein Fehler aufgetreten',
            'LANGDEL': 'Sie haben ',
            'NOADITIONALDEL': 'Sie haben die Option, keine zusätzlichen Sprachen einzustellen, zurückgenommen',
            'ERRORDEL': 'Beim Entfernen der Sprache ist ein Fehler aufgetreten ',
            'MAINPICKED': 'Sie haben bereits die Hauptsprache der Umfrage gewählt.<br><br>Um sie zu ändern, entfernen Sie die gewählte Sprache und wählen Sie eine neue.'
          },
          'CARD1': {
            'TITULO': 'Hauptsprache',
            'ACCION': {
              'PRE': 'Sie haben die Hauptsprache nicht ausgewählt',
              'POST': 'Sie haben die Sprache ausgewählt:'
            },
            'MODAL': {
              'TITULO': 'Wählen Sie die Hauptsprache',
              'ACCION': 'Welche Sprache ist die Hauptsprache der Umfrage?',
              'PLACELISTA': 'Wählen Sie eine Sprache',
              'BOTONES': {
                'ZURÜCK': 'Zurück',
                'OK': 'Fertig'
              }
            }
          },
          'CARD2': {
            'TITULO': 'Zusätzliche Sprachen',
            'ACCION': {
              'PRE': 'Sie haben keine zusätzlichen Sprachen ausgewählt',
              'SINADIC': 'Die Umfrage wird keine zusätzlichen Sprachen haben',
              'POST': 'Sie haben die folgenden Sprachen ausgewählt:',
            },
            'MODAL': {
              'TITULO': 'Wählen Sie zusätzliche Sprachen',
              'ACCION': 'Welche Sprachen möchten Sie der Umfrage hinzufügen?',
              'BOTONES': {
                'ZURÜCK': 'Zurück',
                'OK': 'Fertig'
              }
            }
          }
        },
        'DEMOGRAFICOS': {
            'TAB1': 'Demografisch',
            'TAB2': 'Übersetzen',
            'TAB3': 'Vorschau',
            'COMPLETAR_PASO': 'Schritt abgeschlossen',
            'PASO_COMPLETADO': 'Schritt abgeschlossen',
            'SELECT': 'Eine Option auswählen',
            'BTN_DEMOGRAFICOS': 'Akzeptieren',
            'OPTION_SURVEY': 'Umfrage',
            'OPTION_EXCEL': 'Excel',
            'CONFIGURE_QUESTION': 'Hier klicken, um Frage zu konfigurieren',
            'QUESTION': 'Frage',
            'OPCIONES_RESPUESTA': 'Antwortmöglichkeiten',
            'STATUS': {
              'PEND': 'Schritt abschließen',
              'DONE': 'Schritt beendet'
            }
        },
        'FORALL': {
          'MSJ_PRACTICEREGISTERED': 'Practice saved succesfully',
          'MSJ_DESCRIPTIONREGISTERED': 'Description saved succesfully',
          'MSJ_TRANSLATEREGISTERED': 'Praxis erfolgreich übersetzt',
          'MSJ_DESCRIPTIONTRANSLATED': 'Beschreibung erfolgreich übersetzt',
          'QUESTIONUPDATEDOK': 'Frage erfolgreich aktualisiert',
          'QUESTIONUPDATEDFAIL': 'Fehler, fügen Sie eine gültige Frage ein',
          'RESPONSEUPDATEDOK': 'Antwort erfolgreich aktualisiert.',
          'RESPONSEUPDATEDFAIL': 'Fehler, füge einen gültigen Antworttext ein',
          'TRANSLATEDOK': 'Frageübersetzung erfolgreich gespeichert',
          'INSERTTRANSLATE': 'Bitte, fügen Sie den Translate ein',
          'OPTIONTRANSLATED': 'Option translate succesfully gespeichert',
          'INSERTOPTIONTRANSLATE': 'Bitte, fügen Sie den Translate ein',
          'MJS_SELECTOPTION': 'Bitte wählen Sie eine Option aus',
          'MJS_OPTIONADDED': 'Demografie korrekt hinzugefügt',
          'OPTIONDELETED': 'Demografisch erfolgreich gelöscht',
          'DEMOGRAPHICEXIST': 'Die ausgewählte Bevölkerungsgruppe existiert bereits',
          'AGREGADEMOGRAFICO': 'Auswählen, um weitere demografische Daten hinzuzufügen',


          'SELECCIONE': 'Wählen Sie eine Sprache, um die Vorschau anzuzeigen',
          'IDIOMAS_NOT_SELECTED': 'Zusätzliche languajes, die nicht zum Übersetzen ausgewählt wurden.',
          'PLACEHOLDER': 'Sprache',
          'DESC_TRANSLATE': 'Beschreibung eingeben übersetzen',
          'PRACTICE_TRANSLATE': 'Praxis eingeben übersetzen',
          'IDIOMAS': {
            'Native': 'Einheimisch',
            'es': 'Spanisch',
            'zh1': 'Traditionelles Chinesisch',
            'zh2': 'Vereinfachtes Chinesisch',
            'pt': 'Portugiesisch',
            'en': 'Englisch',
            'vi': 'Vietnamesisch'
            },
            'RESPUESTAS': {
                'Native': 'Nativo',
                'es':{'si': 'SÍ',
                      'no':'NO',
                      'casifalso':'Casi siempre es falso',
                      'false': 'Frecuentemente es falso',
                      'avecesfalse': 'A veces es falso / A veces es verdad',
                      'casiverdad': 'Frecuentemente es verdad',
                      'verdad': 'Casi siempre es verdad'},
                'zh1':{'si': '对','no':'没有',
                      'casifalso':'从来不是这样',
                      'false': '经常不是这样',
                      'avecesfalse': '有时是\有时不是',
                      'casiverdad': '经常是这样',
                      'verdad': '总是这样'},
                'zh2':{'si': '对','no':'没有',
                      'casifalso':'從來不是這樣',
                      'false': '經常不是這樣',
                      'avecesfalse': '有時是\有時不是',
                      'casiverdad': '經常是這樣',
                      'verdad': '總是這樣'},
                'pt':{'si': 'SI','no':'não',
                      'casifalso':'Casi siempre es falso',
                      'false': 'Freqüentemente é falso',
                      'avecesfalse': 'A veces es falso / A veces es verdad',
                      'casiverdad': 'Freqüentemente es verdad',
                      'verdad': 'Casi siempre es verdad'},
                'en':{'si': 'YES','no':'NO',
                      'casifalso':'Almost always untrue',
                      'false': 'Often untrue',
                      'avecesfalse': 'Sometimes untrue/ sometimes true',
                      'casiverdad': 'Often true',
                      'verdad': 'Almost always true'}
              },
          'STATUS': {
            'PEND': 'Schritt abschließen',
            'DONE': 'Schritt beendet'
          },
          'TABLA': {
            'TITULOS': {
              'DEFAULT': 'Hauptsprache',
              'TRADUCCION': 'Übersetzungen',
              'PREVIEW': 'Vorschau'
            },
            'ENCABEZADOS': {
              'PRACT': 'Praxis',
              'DESCR': 'Beschreibung',
              'STT1': 'Anweisung 1',
              'STT2': 'Anweisung 2',
              'LANG': 'Sprache',
            },
            'INPUTS': {
              'PRACT': 'Geben Sie den Praxistext ein',
              'DESCR': 'Geben Sie den Beschreibungstext ein',
            }
          }
        },
        'ADICIONALES': {
          'STATUS': {
            'PEND': 'Schritt abschließen',
            'DONE': 'Schritt beendet'
          },
          'TABS': {
            'QUESTIONS': 'Zusätzliche Fragen',
            'TRANSLATE': 'Übersetzungen',
            'PREVIEW': 'Vorschau'
          },
          'PREGUNTAS':{
            'STATUS': {
              'SIN': 'Sie haben keine zusätzlichen Fragen erstellt',
              'CON': 'Fragen erstellt:',
              'NOADICIONALES': 'Sie haben sich entschieden, keine zusätzlichen Fragen zu erstellen',
              'CANCELNOADIC': 'Sie haben die Option, keine weiteren Fragen zu erstellen, abgebrochen',
              'ERROR': 'Beim Ausführen des Vorgangs ist ein Fehler aufgetreten'
            },
            'ACCIONES': {
              'ADD': 'Eine Frage erstellen',
              'SIN': 'Die Umfrage wird keine zusätzlichen Fragen haben',
            },
            'WIZARD': {
              'NEW': 'Neue Frage',
              'TIPOTITU': 'Klicken Sie hier, um die Zusatzfrage zu konfigurieren',
              'TIPO': {
                'OPEN': 'Offene Frage',
                'UNI': 'Einzelne Optionsfrage',
                'MULT': 'Mehrfach-Optionsfrage'
              },
              'FORM': {
                'TIPO': 'Typ der Frage',
                'TOOLTIP': {
                  'REMOVE': 'Diese Frage entfernen'
                },
                'MENSAJES': {
                  'BORRAR': 'Möchten Sie diese Zusatzfrage löschen?',
                  'PREG_OK': 'Die Frage wurde erfolgreich gespeichert',
                  'PREG_ERR': 'Beim Speichern der Frage ist ein Fehler aufgetreten',
                  'PREG_MOD_OK': 'Die Frage wurde korrekt geändert',
                  'PREG_MOD_ERR': 'Beim Ändern der Frage ist ein Fehler aufgetreten',
                  'OPC_OK': 'Die Antwortoption wurde erfolgreich gespeichert',
                  'OPC_ERR': 'Beim Speichern der Antwortoption ist ein Fehler aufgetreten',
                  'OPC_MOD_OK': 'Die Antwortoption wurde korrekt geändert',
                  'OPC_MOD_ERR': 'Beim Modifizieren der Antwortoption ist ein Fehler aufgetreten',
                  'PREG_DEL_OK': 'Die Frage wurde erfolgreich gelöscht',
                  'PREG_DEL_ERR': 'Beim Löschen der Frage ist ein Fehler aufgetreten',
                  'OPC_DEL_OK': 'Die Antwortoption wurde erfolgreich gelöscht',
                  'OPC_DEL_ERR': 'Beim Löschen der Antwortoption ist ein Fehler aufgetreten',
                },
                'BOTONES':{
                  'SI': 'Ja',
                  'NO': 'Nein'
                }
              },
              'ABIERTA': {
                'TITULO': 'Neue offene Frage',
                'ACCION': 'Geben Sie den Fragentext ein',
                'ERROR': 'Sie haben den Fragentext nicht eingegeben',
              },
              'MULTI':{
                'TITULOSING': 'Neue Einzeloptionsfrage',
                'TITULOMULT': 'Neue Mehrfach-Optionsfrage',
                'ACCION': 'Geben Sie den Fragentext ein',
                'ERROR': 'Sie haben den Fragentext nicht eingegeben',
                'MENSAJES': {
                  'BORRAR': 'Möchten Sie diese Antwortoption löschen?',
                  'SINPREG': 'Sie können keine Option eingeben, bis Sie den Fragentext eingegeben haben',
                  'SINANTE': 'Sie können diesen Antwortoptionstext erst eingeben, wenn Sie den vorherigen Antwortoptionstext eingegeben haben'
                },
                'OPCIONES': {
                  'TITU': 'Antwortmöglichkeiten',
                  'INPUT': {
                  'TITU': 'Antwortmöglichkeit',
                  'ERROR': 'Sie haben den Text für die Antwortoption nicht eingegeben'
                  }
                },
                'TOOLTIP': {
                  'ADD': 'Eine Antwortoption hinzufügen',
                  'MOVE': 'Antwortoption verschieben',
                  'REMOVE': 'Diese Antwortoption entfernen'
                }
              }
            }
          },
          'TRADUCCIONES': {
            'TITULO': 'Wählen Sie eine Sprache, um mit der Eingabe der Übersetzungstexte zu beginnen',
            'TITULOALTERNO': 'Sie haben im Bereich "Sprachen" keine zusätzliche Sprache ausgewählt',
            'NOTYET': 'Die Übersetzung ist noch nicht abgeschlossen',
            'MAIN': 'Hauptsprache',
            'INPUT': {
              'NEW': 'Geben Sie die Frageübersetzung ein',
              'ERROR': 'Sie haben die Frageübersetzung nicht eingegeben!',
              'NEWOPC': 'Geben Sie die Übersetzung der Antwortoption ein',
              'ERROROPC': 'Sie haben die Übersetzung der Antwortoption nicht eingegeben!'
            },
            'MENSAJES': {
              'PREG_OK': 'Der Übersetzungstext wurde erfolgreich gespeichert',
              'PREG_ERR': 'Beim Speichern des Übersetzungstextes ist ein Fehler aufgetreten',
              'PREG_MOD_OK': 'Der Übersetzungstext wurde korrekt aktualisiert',
              'PREG_MOD_ERR': 'Beim Aktualisieren des Übersetzungstextes ist ein Fehler aufgetreten',
              'OPC_NOPREG': 'Der Übersetzungstext für diese Option kann erst gespeichert werden, wenn der Fragentext gesetzt ist',
              'OPC_OK': 'Der Übersetzungstext wurde erfolgreich gespeichert',
              'OPC_ERR': 'Beim Speichern des Übersetzungstextes ist ein Fehler aufgetreten',
              'OPC_MOD_OK': 'Der Übersetzungstext wurde korrekt aktualisiert',
              'OPC_MOD_ERR': 'Beim Aktualisieren des Übersetzungstextes ist ein Fehler aufgetreten',
            },
            'COMPLETE': 'Übersetzung komplett '
          },
          'PREVIEW': {
            'TITULO': 'Wählen Sie eine Sprache, um die Übersetzungen der Zusatzfragen anzuzeigen',
            'SINPREV': 'Es gibt keine übersetzten Texte für die ausgewählte Sprache',
            'LOADING': 'Daten werden geladen',
            'INPUT': {
              'RESPABIERTA': 'Schreiben Sie Ihre Antwort',
              'ERRORABIERTA': 'Sie haben Ihre Antwort nicht geschrieben!',
              'ELIGELANG': 'Wählen Sie eine Sprache'
            },
            'HELP': {
              'SINGLE': 'Sie dürfen bei dieser Frage nur eine Option wählen',
              'MULTI': 'Sie können bei dieser Frage mehr als eine Option wählen'
            }
          }
        },
        'COLABORADORES': {
          'TITULO':'Arbeitsplatzblatt herunterladen',
          'TITULOCT':'Arbeitsplatzliste',
          'SHEET':{
            'NUMBER':'Blattname'
          },

          'STATUS': {
            'PEND': 'Schritt abgeschlossen',
            'DONE': 'Schritt abgeschlossen',
            'LOCK': 'Durchgang wieder öffnen',
          },
          'STATUSBAR': {
            'NOBD': 'Sie haben die Teilnehmerdatenbank nicht geladen',
            'PROCES': 'Die Teilnehmerdatenbank ist noch nicht gespeichert',
            'ERROR': 'Es wurden Fehler in der geladenen Datei gefunden',
            'OK': 'Die Teilnehmerdatenbank ist korrekt gespeichert'
          },
          'CARD_BD': {
            'TITULO': 'Information: ',
            'NUMCOLABS': 'Anzahl der Teilnehmer',
            'NUMCENTER': 'Anzahl der Arbeitsplätze',
            'FECHA': 'Upload-Datum',
            'ACCIONES': 'Aktionen: ',
            'WANNADO': 'Was wollen Sie tun?',
            'BOTONES': {
              'DESCARGA': 'Die Teilnehmerdatenbank herunterladen',
              'ELIMINA': 'Löschen Sie die Teilnehmerdatenbank'
            }
          },
          'CARD_NOBD': {
            'TITULO': 'Folgen Sie diesen Schritten, um Ihre Teilnehmerdaten in CULTURAL GO® hochzuladen',
            'PASOS': {
              '1': 'Laden Sie die Vorlage für die Teilnehmerdatenbank herunter',
              '2': 'Füllen Sie die Vorlage mit Ihren Teilnehmerinformationen auf der Grundlage der bereitgestellten Spalten aus',
              '3': 'Laden Sie die Datei mit Ihren Teilnehmerdaten hoch'
            },
            'TOOLTIP': 'Diese Datei enthält Makros zur Datenüberprüfung'
          },
          'CARD_NOERR': {
            'TITULO': 'Information',
            'NUMCOLABS': 'Anzahl der Teilnehmer in der geladenen Datei',
            'NUMCT': 'Anzahl der Arbeitsplätze in der geladenen Datei',
            'FILENAME': 'Name der Datei',
            'GUARDAR': 'Wollen Sie diese Information speichern?',
            'BOTONES': {
              'SI': 'Ja',
              'NEIN': 'Nein'
            }
          },
          'CARD_ERRFND': {
            'TITULO': 'Information',
            'ROWS_OK': 'Anzahl der richtigen Zeilen',
            'ROWS_NOTOK': 'Anzahl der Zeilen mit Fehlern',
            'MOREINFO': '* Die Fehlerliste im Detail wird unten angezeigt',
            'FILENAME': 'Name der Datei',
            'GUARDAR': 'Die geladenen Informationen können nicht gespeichert werden',
            'DELETE': 'Datei löschen'
          },
          'CARD_ERRLIST': {
            'TITULO': {
              '1': 'Zeilen mit Fehlern: ',
              '2': 'Insgesamt gefundene Fehler: ',
              '3': 'Teilnehmerdaten'
            },
            'INFO': {
              'ROW': 'Zeile',
              'ERRNUM': 'Anzahl der Fehler: ',
              'SHOW': 'Klicken Sie hier, um die Fehler dieser Zeile anzuzeigen'
            },
            'DETALLE': {
              'TIPO': 'Art des Fehlers',
              'DESCR': 'Beschreibung',
              'COLUMNA': 'Spalte',
              'DATO': 'Falsche Daten'
            },
            'ERRORES': {
              'alfabetica': 'Alphabetische ungültige Daten',
              'alfanumerica': 'Alphanumerische ungültige Daten',
              'numerica': 'Numerische ungültige Daten',
              'email': 'E-Mail ungültige Syntax',
              'vacio': 'Leere Zelle',
              'columna': 'Unbekannte Spalte',
              'CT': 'Arbeitsplatz nicht gefunden',
              'catSurvey': 'Unbekannte Daten',
              'repetido': 'Mitarbeiterschlüssel ist doppelt vorhanden',
              'repetidoMail': 'E-Mail ist doppelt vorhanden',
              'clavenumerica': 'Invalidez de clave',

            },
            'DESCRIPCION': {
              'alfabetica': 'Die Information hat ein oder mehrere ungültige Zeichen. Nur alphabetische Zeichen (A - Z) und die folgenden Sonderzeichen: [( ) . , : -] sind erlaubt ',
              'alfanumerica': 'Die Information hat ein oder mehrere ungültige Zeichen. Nur alphabetische Zeichen (A - Z), numerische Zeichen (0 - 9) und die nächsten Sonderzeichen: [( ) . , : -] sind erlaubt ',
              'numerica': 'Die Information hat ein oder mehrere ungültige Zeichen. Nur numerische Zeichen (0 - 9) sind erlaubt',
              'email': 'Die Information hat nicht die richtige E-Mail-Syntax ( mail@domain.com )',
              'vacio': 'Die Zelle enthält keine Informationen. Diese Spalte ist obligatorisch.',
              'columna': 'Die Spalte gehört nicht zu der von CulturalGO bereitgestellten Vorlage',
              'CT': 'Der angegebene Arbeitsplatz in dieser Zeile wurde nicht in der Liste der verfügbaren Arbeitsplätze gefunden',
              'catSurvey': 'Die Informationen stimmen nicht mit dem Katalog überein',
              'repetido': 'Der Arbeitgeberschlüssel kann nicht dupliziert werden',
              'repetidoMail': 'Die E-Mail kann nicht dupliziert werden',
              'clavenumerica':'Die Information hat ein oder mehrere ungültige Zeichen. Erlaubt sind nur alphabetische Zeichen (A - Z), numerische Zeichen (0 - 9) und das nächste Sonderzeichen: -',

            }
          },
          'CARD_LOAD': {
            'CARGA': {
              'TITULO': 'Laden',
              'INFO': 'Analysieren der Dateiinformationen, bitte einen Moment warten'
            },
            'GUARDA': {
              'TITULO': 'Saving',
              'INFO': 'Speichern der Informationen ins System, bleiben Sie in dieser Maske, bis der Speichervorgang beendet ist'
            },
          },
          'MENSAJES': {
            'GUARDA_1': 'Bestätigen Sie das Speichern der Informationen von ',
            'GUARDA_2': ' Teilnehmer bzw. Arbeitsplätze?',
            'GUARDADO': 'Die Teilnehmerdatenbank wurde erfolgreich gespeichert',
            'GUA_ERR': 'Beim Speichern der Informationen ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal',
            'DELETE_1': 'Bestätigen Sie das Löschen der Informationen von ',
            'DELETE_2': ' Teilnehmer bzw. Arbeitsplätze?',
            'DEL_OK_1': 'Die Informationen ',
            'DEL_OK_2': 'wurde erfolgreich gelöscht',
            'DEL_ERR': 'Beim Löschen der Teilnehmerdatenbank ist ein Fehler aufgetreten. Versuchen Sie es später erneut',
            'DELFILE': 'Die Datenbankdatei wurde korrekt entfernt',
            'EXCEL': 'Exceldatei wird erzeugt, bitte warten Sie einen Moment',
            'EXTMAL': 'Die ausgewählte Datei hat nicht die richtige Erweiterung. Es darf nur die von CulturalGO bereitgestellte Vorlagendatei hochgeladen werden',
            'NOROWS': 'Die ausgewählte Datei hat keinen Datensatz',
            'VACIO': 'Die ausgewählte Datei ist leer, oder die Teilnehmerinformationen sind nicht im ersten Blatt enthalten',
            'BOTONES': {
              'SI': 'Ja',
              'NO': 'Nein'
            }
          },
          'EXCELINFO': {
            'HOJA': 'Teilnehmerdaten',
            'TITULO': 'Teilnehmerdatenbank',
            'AUTOR': 'CulturalGO',
            'ASUNTO': 'Heruntergeladen von Plattform'
          },
          'UPLOAD': 'Klicken Sie hier, um die Teilnehmerdatenbank zu durchsuchen',
          'REMOVE': 'Aus dem Upload entfernen',
          'SEND': 'An die Datenbank senden',
          'PROCESO': {
            'STP1': 'Analysieren der Teilnehmerdatenbank',
            'STP2': 'Sichern der Teilnehmerdatenbank',
          }
        }
      },
      'PDF':{
        'TITLE':'Beweiskatalog für das NOM-035-STPS-2018',
        'IND':'Index',
        'MAIN1':'I. Zielsetzung',
        'MAIN2':'II. Umfang',
        'MAIN3':'III. Nachweise',
        'INCISOA':'a) Dokumentarischer Nachweis der psychosozialen Risikoprävention',
        'INCISOB':'b) Informationen aus dem verwendeten Fragebogen',
        'INCISOC':'c) Informationen über Präventionsmaßnahmen für psychosoziale Risikofaktoren',
        'INCISOD':'d) Informationen zu den Kontrollmaßnahmen am Arbeitsplatz',
        'INCISOE':'e) Informationen über Maßnahmen zur Identifizierung von Arbeitnehmern',
        "INCISOF": "f) Angaben über die Betreuung der exponierten Arbeitnehmer",
        'INCISOH':'g) Aufzeichnungen über Maßnahmen, die an Arbeitnehmern durchgeführt wurden',
        'PARRAFO1':'Stellen Sie in einem einzigen Dokument die Zugangslinks zu den in Punkt 10 "Verfahren zur Konformitätsbewertung" von NOM-035-STPS-2018 geforderten Nachweisen zur Verfügung',
        'PARRAFO2':'Dieses Dokument stellt die Nachweise zusammen, die gemäß Punkt 10 der NOM-035-STPS-2018 auf der CGO-Plattform hinzugefügt werden.',
        'SECCION1':'CGO Seccion',
        'SECCION2':'Kommentare',
        'SECCION3':'Link',
        'BTN':'PDF erstellen'
      },
      'TIMELINE':{
        'ETAPA1':{
          'SECCION1':{
            'actividad': "Erstellen einer Präventionspolitik für psychosoziale Risiken, die die Prävention von psychosozialen Risikofaktoren und Gewalt am Arbeitsplatz in Betracht zieht und ein günstiges Organisationsumfeld fördert.",
            'entregable': "Policy.",

          },
          'SECCION2':{
            'actividad': "Erzeugen Sie den Umfrageprozess und definieren Sie Datensätze zur Durchführung der Umfrage.",
            'entregable': "Prozessablauf",
          },
          'SECCION3':{
            'actividad': "Umfrageprozess generieren und Datensätze für das Umfrageverhalten definieren",
            'entregable': "Prozessablauf.",

          },
          'SECCION4':{
            'actividad': "Organisationsentwicklungsplan erstellen, der eine Kultur der Prävention fördert und ein günstiges Organisationsumfeld schafft.",
            'entregable': "Kampagne 'Förderung von NOM-035', Umsetzungsplan und durchzuführende Aktivitäten",

          },
          'SECCION5':{
            'actividad': "Verbreitungskampagne zur Vorbeugung psychosozialer Risiken, zu den ergriffenen Maßnahmen, zur Vorbeugung möglicher Arbeitsrisiken und zum Beschwerdemechanismus.",
            'entregable': "Kampagne 'Förderung von NOM-035', Umsetzungszeitplan und durchzuführende Aktivitäten.",

          },
          'SECCION6':{
            'actividad': "Verwendung von CGO für die Aufbewahrung von Aufzeichnungen und die Überwachung von Arbeitnehmern",
            'entregable': "Aufzeichnungen von Arbeitern",
          },
          'SECCION7':{
            'actividad': "Verwendung von CGO für die Aufbewahrung von Aufzeichnungen und die Überwachung von Arbeitern.",
            'entregable': "Job-Profil",
          },
          'SECCION8':{
            'actividad': "Verwendung von CGO für die Aufbewahrung von Aufzeichnungen und die Überwachung von Arbeitnehmern.",
            'entregable': "Job-Profil",
          },
          'SECCION9':{
            'actividad': "Verwendung von CGO für die Aufbewahrung von Aufzeichnungen und die Überwachung von Arbeitnehmern.",
            'entregable': "Job-Profil",
          },
          'SECCION10':{
            'actividad': "Hotline-Prozess mit Definition von negativer Führung und negativen Arbeitsbeziehungen.",
            'entregable': "Prozessablauf.",
          },
          'SECCION11':{
            'actividad': "Bewertungsprozess des günstigen organisatorischen Umfelds",
            'entregable': "Prozessablauf",
          },
          'SECCION12':{
            'actividad': "Integration der GPTW-Kultur in die Belegschaft",
            'entregable': "Kampagne 'Förderung von NOM-035', Umsetzungszeitplan und durchzuführende Aktivitäten",
          },
          'SECCION13':{
            'actividad': "Tätigkeitsprofile mit Risikoanalyse im Arbeitsbereich",
            'entregable': "Tätigkeitsprofil",
          },
          'SECCION14':{
            'actividad': "Job-Profile mit Risikoanalyse im Arbeitsbereich",
            'entregable': "Tätigkeitsprofil",
          },
          'SECCION15':{
            'actividad': "Sicherheits- und Hygienetourprozess und dessen Bericht generieren",
            'entregable': "Prozessablauf.",

          },
          'SECCION16':{
            'actividad': 'NOM-035 Umfrageprozess',
            'entregable': "Prozessablauf",

          },
          'SECCION17':{
            'actividad': "Verbreitungskampagne über die Politik zur Prävention psychosozialer Risiken, die ergriffenen Maßnahmen, die Prävention möglicher Arbeitsrisiken und den Mechanismus für Beschwerden.",
            'entregable': "Kampagne 'Förderung von NOM-035', Umsetzungszeitplan und durchzuführende Aktivitäten.",

          },
          'SECCION18':{
            'actividad': "Prozess der Reklamationslinie",
            'entregable': "Prozessablauf",
          },
          'SECCION19':{
            'actividad': "Maßnahmen und Programme zur Prävention von psychosozialen Risikofaktoren, zur Förderung eines günstigen Organisationsumfelds und zur Prävention von Gewalt am Arbeitsplatz.",
            'entregable': "Kampagne 'Förderung von NOM-035', Umsetzungszeitplan und durchzuführende Aktivitäten.",
          }

        },
        'ETAPA2':{
          'SECCION1':{
            'actividad': "Erstellen eines Prozesses für die Kanalisierung von Arbeitnehmern mit schweren traumatischen Ereignissen, die in der Umfrage identifiziert wurden.",
            'entregable': "Prozessablauf",

          },
          'SECCION2':{
            'actividad' : "Generate a process for the channeling of workers with severe traumatic events that were identified in the survey.",
            'entregable': "Prozessablauf",

          },
          'SECCION3':{
            'actividad' : "Prozess zur Kommunikation der Ergebnisse.",
            'entregable': "Prozessablauf",

          },
          'SECCION4':{
            'actividad' : "Prozess zur Erstellung von Umfragen und Definition von Umfragedurchführungsprotokollen.",
            'entregable': "Prozessablauf",

          },
          'SECCION5':{
            'actividad' : "Jährlicher Trainingsplan und Verknüpfung von Korrekturmaßnahmen und kontinuierlicher Verbesserung.",
            'entregable': "Jährlicher Schulungsplan und Prozessablauf für Korrekturmaßnahmen",

          },
          'SECCION6':{
            'actividad' : "Interne Kommunikationsrichtlinie.",
            'entregable': "Richtlinie",

          },
          'SECCION7':{
            'actividad' : "Interne Kommunikationsrichtlinie",
            'entregable': "Richtlinie",

          },
          'SECCION8':{
            'actividad' : "Schulungsplan",
            'entregable': "Jährlicher Trainingsplan",

          },
          'SECCION9':{
            'actividad' : "Interne Kommunikationspolitik.",
            'entregable': "Richtlinie",

          },
          'SECCION10':{
            'actividad' : "Erkennungssysteme",
            'entregable': "Anerkennungspolitik und -mechanismen",

          },
          'SECCION11':{
            'actividad' : "NOM-035 Erhebungsprozess.",
            'entregable': "Prozessablauf.",

          },
          'SECCION12':{
            'actividad' : "Trifft nicht zu, da die Standardumfrage verwendet wird.",
            'entregable': "N/A.",

          },
          'SECCION13':{
            'actividad' : "Tätigkeitsprofile mit Risikoanalyse im Arbeitsbereich.",
            'entregable': "Job-Profil.",

          },
          'SECCION14':{
            'actividad' : "Job-Profile mit Risikoanalyse im Arbeitsbereich.",
            'entregable': "Job-Profil",

          },
          'SECCION15':{
            'actividad' : "Es wird von der CGO-Plattform generiert",
            'entregable': "Bericht.",

          },
          'SECCION16':{
            'actividad' : "Kommunizieren Sie die Ergebnisse der psychosozialen Risikobewertung.",
            'entregable': "Prozessablauf und Richtlinie",

          },
          'SECCION17':{
            'actividad' : "Organisationsentwicklungsplan zur Verbesserung der Kommunikation, des Zugehörigkeitsgefühls, der Beteiligung an der kontinuierlichen Verbesserung, der Bewertung und der Anerkennung der Leistung.",
            'entregable': "Organisationsentwicklungsplan.",

          },
          'SECCION18':{
            'actividad' : "DNC alle zwei Jahre.",
            'entregable': "Prozessablauf, DNC-Bericht",
          },
          'SECCION19':{
            'actividad' : "Jährlicher Trainingsplan und Verknüpfung von Korrekturmaßnahmen und kontinuierlicher Verbesserung.",
            'entregable': "Trainingsplan, Prozessablauf."
          },
          'SECCION20':{
            'actividad': "Prozess für Korrekturmaßnahmen und seine Anpassung an NOM-035.",
            'entregable': "Prozessablauf.",
          }
        }

      }

    }
};
